import Router from '@/router';
import Store from '@/store';
import { getIrInputStoreId } from '@/utils/api';

export const resolveStoreId = () => {
	return getIrInputStoreId();
};

export const resolvePageId = () => {
	const route = Router.currentRoute;
	const { pageId } = route.query;
	const realPageId = pageId || Store.getters.getPageId;
	return realPageId;
};
